module.exports = __webpack_public_path__ + "static/media/Orbit-hubble.571c19ae.png";